module.exports = __webpack_public_path__ + "static/18-39b98afc1c2ab21a0180ae8e1330de72.png";